import React, { useState, useEffect } from 'react';
import { API_VERSION_QUERY, DATABASE_VERSION_QUERY, GQL_VERSION_QUERY, INSURANCE_SERVICE_VERSION_QUERY } from '../queries';
import { ERP_VERSION, REQUEST_DEIMOS_VERSION } from '../mutations';
import { ERP_VERSION_DATA, DEIMOS_VERSION } from '../subscriptions';
import { useSimpleError, useQueryWithSimpleErrorHandling } from 'hooks';
import { useMutation, useConditionalSubscription } from 'features/common/security/hooks';
import VersionsComponent from './VersionsComponent';

const initialErpVersion = {
  clientId: '',
  version: '',
  loading: true
};
const VersionsContainer = () => {
  const showError = useSimpleError();
  const { loading: loadingAPIVersion, data: apiVersionData, error: apiVersionError } = useQueryWithSimpleErrorHandling(API_VERSION_QUERY);

  const { loading: loadingInsuranceServiceVersion, data: insuranceServiceVersionData } =
    useQueryWithSimpleErrorHandling(INSURANCE_SERVICE_VERSION_QUERY);

  const { loading: loadingDatabaseVersion, data: databaseVersionData } = useQueryWithSimpleErrorHandling(DATABASE_VERSION_QUERY);

  const { loading: loadingGqlVersion, data: gqlVersionData } = useQueryWithSimpleErrorHandling(GQL_VERSION_QUERY);

  const [erpVersion, setERPVersion] = useState(initialErpVersion);
  const databaseVersion = databaseVersionData && databaseVersionData.databaseVersion;
  const apiVersion = apiVersionData && apiVersionData.apiVersion;
  const gqlVersion = gqlVersionData && gqlVersionData.gqlVersion;
  const insuranceServiceVersion = insuranceServiceVersionData && insuranceServiceVersionData.insuranceServiceVersion;
  const [deimosVersion, setDeimosVersion] = useState();

  const [erpVersionData] = useMutation(ERP_VERSION, {
    onError: error => {
      showError(error);
      setERPVersion({ ...initialErpVersion, loading: false });
    }
  });

  const [deimosVersionData] = useMutation(REQUEST_DEIMOS_VERSION, {
    onError: error => {
      showError(error);
    }
  });

  useEffect(() => {
    erpVersionData({ variables: {} });
  }, [erpVersionData]);

  useEffect(() => {
    deimosVersionData({ variables: {} });
  }, [deimosVersionData]);

  useConditionalSubscription(ERP_VERSION_DATA, {
    onData: ({ data: { data } }) => {
      if (data.erpVersionData) {
        setERPVersion({ clientId: data.erpVersionData.clientId, version: data.erpVersionData.version, loading: false });
      }
    }
  });

  useConditionalSubscription(DEIMOS_VERSION, {
    onData: ({ data: { data } }) => {
      if (data?.deimosVersionRetrieved) {
        setDeimosVersion({
          version: data.deimosVersionRetrieved.version,
          date: data.deimosVersionRetrieved.date
        });
      }
    }
  });

  return (
    <VersionsComponent
      loadingAPIVersion={loadingAPIVersion}
      apiVersionError={apiVersionError}
      apiVersion={apiVersion}
      loadingInsuranceServiceVersion={loadingInsuranceServiceVersion}
      insuranceServiceVersion={insuranceServiceVersion}
      loadingGqlVersion={loadingGqlVersion}
      gqlVersion={gqlVersion}
      loadingDatabaseVersion={loadingDatabaseVersion}
      databaseVersion={databaseVersion}
      erpVersion={erpVersion}
      deimosVersion={deimosVersion}
    />
  );
};

export default VersionsContainer;
